import _get from 'lodash/get';

import processPaymentServices from '@/utilities/processPaymentServices';

import {
    inventoryDuck,
    ownersDuck,
    preorderOwnersDuck,
} from '@/ducks';

import { vdpResultsDuck } from '@/ducks/vdp';

export default function dispatchBuildAndPricePageData() {
    return async (ctx) => {
        const {
            brand: [, { paymentDealerId, paymentPartnerId }],
            nds_calc: [, { forceDefaultRates }],
            nds_lease: [isNdsLeaseEnabled, leaseEnabledDRTypes = {}],
            nds_price_breakdown: [isPriceBreakdownEnabled, priceBkdwnEnabledDRTypes = {}],
            non_dt_payment_services: [enabledNonDTPaymentServices],
            use_fba_payment_calc: [enableFBAPaymentCalc],
        } = ctx.useFeatures([
            'brand',
            'nds_calc',
            'nds_lease',
            'nds_price_breakdown',
            'non_dt_payment_services',
            'use_fba_payment_calc',
        ]);

        // Create batched action queue
        ctx.batchDispatch.createActions((deferredCtx) => {

            const {
                preorder,
                vdpListing,
            } = deferredCtx.data;

            const owners = [];
            _get(preorder, 'customOrders', []).forEach((item) => {
                const ownerList = item.owner || [];
                ownerList.forEach((owner) => {
                    owners.push(owner);
                });
            });

            const ownerIds = owners.map((owner) => owner.id);

            if (vdpListing && vdpListing.paymentServices) {
                processPaymentServices(vdpListing, {
                    paymentDealerId,
                    paymentPartnerId,
                    forceDefaultRates,
                    isNdsLeaseEnabled,
                    leaseEnabledDRTypes,
                    priceBkdwnEnabledDRTypes,
                    isPriceBreakdownEnabled,
                    enabledNonDTPaymentServices,
                    enableFBAPaymentCalc,
                });
            }

            // if no vdp listing is supplied from server, then assume inventory data still exists in redux
            const optionalActions = vdpListing ? [
                inventoryDuck.creators.addVdpInventory(vdpListing),
                vdpResultsDuck.creators.setActiveResults([vdpListing?.id]),
            ] : [];

            return [
                // Add owner(s) to owner collection
                ownersDuck.creators.addOwners(owners || []),

                preorderOwnersDuck.creators.setKeys({ ownerIds }),

                ...optionalActions,
            ];

        });

        // dispatch the batched action queue
        await ctx.batchDispatch.dispatchActions(ctx);
    };
}
